module.exports = __webpack_public_path__ + "img/14.6919ec40.webp";